export default {
  data() {
    return {
      headers: [],
      hashText: ''
    };
  },
  mounted() {
    this.getHeadersData();
    this.getHashText();
  },
  watch: {
    $route() {
      this.headers = this.$page.headers;
      this.getHashText();
    }
  },
  methods: {
    getHeadersData() {
      this.headers = this.$page.headers;
    },
    getHashText() {
      this.hashText = decodeURIComponent(window.location.hash.slice(1));
    }
  }
};